import React from "react";
import { Tooltip } from "~/native-ui/Tooltip";
import { SpinnerButton, } from "./SpinnerButton"

export const SaveButton = React.memo(
    React.forwardRef((props) => {
        return (
            <Tooltip key="save" disabled={props.disabled} tooltip={props.label} rightMargin>
                <SpinnerButton
                    primary
                    disabled={props.disabled}
                    icon={props.icon ?? (!props.disabled ? 'save' : 'done-all')}
                    iconSize="sm"
                    onPress={props.onPress || props.onClick}
                    children={props.label}
                />
            </Tooltip>
        )
    })
)